<template>
  <v-layout column class="info-width">
    <!-- MESSAGES -->
    <v-dialog
      v-model="showMessage"
      max-width="390"
      persistent
    >
      <v-card width="390">
        <v-card-title primary-title>
          <div>
            <div class="headline">{{ messageToShow }}</div>
            <span>
              Ésta alarma ha sido justificada por otro usuario.
            </span>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="closeMessage"
          >
            <v-icon left>clear</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- JUSTIFICATION COMPONENT -->
    <v-dialog
      v-model="showJustification"
      max-width="390"
      persistent
    >
      <justification-alert
        :alarm='alarmSelected'
        @showDialog='showJustification = false'
        @showMessage='showMessageIn'
      />
    </v-dialog>
    <!-- INFO ALARMS -->
    <v-flex d-inline-flex align-center class="general-info-container" pa-3 mb-1>
      <v-flex style="max-width: 350px; min-width: 350px;">
        <h2>En Movimiento sin Autorización</h2>
      </v-flex>
      <v-flex
        v-if="!loadingMovementAlarms"
        style="max-width: 190px; min-width: 190px;"
      >
        <h3 class="pl-2"><span class="body-2">Total Alarmas:</span> {{ movementAlarms.length }}</h3>
      </v-flex>
    </v-flex>
    <!-- HEADER -->
    <v-flex d-flex pa-1 mb-1 class="header-container">
      <v-flex class="cell-width-0 text-xs-left" pl-4>Quien</v-flex>
      <v-flex class="cell-width-2 text-xs-center">Agencia</v-flex>
      <v-flex class="cell-width-1 text-xs-center">Que</v-flex>
      <v-flex class="cell-width-2 text-xs-center">Desde</v-flex>
      <v-flex class="cell-width-2 text-xs-center">Hasta</v-flex>
      <v-flex class="cell-width-3 text-xs-center">Duración</v-flex>
      <v-flex class="cell-width-3 text-xs-center">Justificación</v-flex>
    </v-flex>
    <!-- LOADING -->
    <v-flex v-if="loadingMovementAlarms" pa-5>
      <v-progress-circular indeterminate color="white"></v-progress-circular>
      Cargando datos...
    </v-flex>
    <!-- CONTENT -->
    <v-flex v-else>
      <!-- ALARM DATA -->
      <v-flex v-if="movementAlarms.length > 0">
        <v-flex
          v-for="alarm in movementAlarms"
          :key="alarm.alarmId"
          mb-1
        >
          <v-card flat>
            <v-flex
              class="info-width"
              d-inline-flex
              align-center
              pa-1
            >
              <v-flex class="cell-width-0 text-xs-left" pl-4>
                <router-link :to="`/vehicles/${vehicleId(alarm.device)}`">
                  <v-flex>
                    <v-flex class="small-text">Código/Sigla</v-flex>
                    <v-flex><b>{{ vehicleCode(alarm.device) }}</b></v-flex>
                  </v-flex>
                  <v-flex pt-1>
                    <v-flex class="small-text">Placa</v-flex>
                    <v-flex><b>{{ alarm.licensePlate }}</b></v-flex>
                  </v-flex>
                </router-link>
              </v-flex>
              <v-flex class="cell-width-2 text-xs-center">
                {{ getAgencyId(alarm.device) | agencyName }}
              </v-flex>
              <v-flex class="cell-width-1 text-xs-center">
                En Movimiento sin Autorización
              </v-flex>
              <v-flex class="cell-width-2 text-xs-center">
                {{ alarm.initialDate | filterFullDate }}
              </v-flex>
              <v-flex class="cell-width-2 text-xs-center">
                {{ alarm.finalDate | filterFullDate }}
              </v-flex>
              <v-flex class="cell-width-3 text-xs-center hover-custom" @click="toggleUnit">
                {{ duration(alarm) }}
              </v-flex>
              <v-flex class="cell-width-3 text-xs-center">
                <!-- NULL -->
                <v-flex
                  v-if="alarm.justification.isJustified === null"
                  :class="alarm.justification.userInProgressRemote ? 'in-progress-state' : ''"
                  d-inline-flex
                  align-center
                >
                  <v-btn
                    fab
                    small
                    flat
                    :disabled="alarm.justification.justificationInProgress"
                    @click.stop="justifyAlert({
                      alarmId: alarm.alarmId,
                      justification: alarm.justification,
                      licensePlate: alarm.licensePlate,
                      code: vehicleCode(alarm.device)
                    })"
                  >
                    <v-icon
                        v-if="alarm.justification.userInProgressRemote"
                        color="grey lighten-1"
                      >
                        textsms
                      </v-icon>
                      <v-icon
                        v-else
                        color="grey lighten-1"
                      >
                        chat_bubble
                      </v-icon>
                  </v-btn>
                  <!-- USER IN PROGRESS -->
                  <v-tooltip
                    left
                    color="amber lighten-2 grey--text text--darken-3"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-if="alarm.justification.userInProgressRemote"
                        class="hover-icon"
                        style="margin-left:-15px"
                        color="amber"
                        v-on="on"
                      >
                        record_voice_over
                      </v-icon>
                    </template>
                    <span style="color:#424242">
                      ...justificando
                      <br />
                        <b>{{ alarm.justification.userInProgressRemote }}</b>
                    </span>
                  </v-tooltip>
                </v-flex>
                <!-- FALSE -->
                <v-btn
                  v-else-if="alarm.justification.isJustified === false"
                  fab
                  small
                  flat
                  @click.stop="justifyAlert({
                    alarmId: alarm.alarmId,
                    justification: alarm.justification,
                    licensePlate: alarm.licensePlate,
                    code: vehicleCode(alarm.device)
                  })"
                >
                  <v-icon color="error">report_off</v-icon>
                </v-btn>
                <!-- TRUE -->
                <v-btn
                  v-else-if="alarm.justification.isJustified === true"
                  fab
                  small
                  flat
                  @click.stop="justifyAlert({
                    alarmId: alarm.alarmId,
                    justification: alarm.justification,
                    licensePlate: alarm.licensePlate,
                    code: vehicleCode(alarm.device)
                  })"
                >
                  <v-icon color="success">message</v-icon>
                </v-btn>
              </v-flex>
            </v-flex>
          </v-card>
        </v-flex>
      </v-flex>
      <!-- MESSAGE -->
      <v-flex v-else px-3 py-3>
        <h2>En éste momento no hay alarmas por movimientos sin autorización.</h2>
        <p>A medida que se generen nuevas alarmas, éstas se cargaran automáticamente.</p>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import JustificationAlert from '../components/JustificationAlert'

  export default {
    name: 'movement-alerts',
    components: {
      JustificationAlert
    },
    data() {
      return {
        toggleUnitState: false,
        intervalMovementAlarmsValue: 20000,
        intervalMovementAlarmsInstance: null,
        showJustification: false,
        alarmSelected: {},
        showMessage: false,
        messageToShow: ''
      }
    },
    computed: {
      ...mapGetters({
        adminRole: 'auth/adminRole',
        user: 'auth/getProfile'
      }),
      ...mapGetters([
        'getAgencyId',
        'vehicleId',
        'pusherRef',
        'vehicleCode',
        'loadingMovementAlarms',
        'movementAlarms'
      ])
    },
    methods: {
      ...mapActions([
        'clearMovementAlarms',
        'fetchMovementAlarms',
        'setLoadingMovementAlarms'
      ]),
      duration(alarm) {
        let result = `${alarm.duration} seg`
        if (this.toggleUnitState) {
          result = alarm.duration / 60
          result = `${result.toFixed(2)} min`
        }
        return result
      },
      toggleUnit() {
        // console.log('TOGGLE UNIT')
        this.toggleUnitState = !this.toggleUnitState
      },
      intervalForMovementAlarms() {
        this.intervalMovementAlarmsInstance = setInterval(() => {
          this.fetchMovementAlarms()
        }, this.intervalMovementAlarmsValue)
        // console.log('intervalForMovementAlarms', this.intervalMovementAlarmsInstance)
      },
      justifyAlert(alarm) {
        if (alarm.justification.isJustified === null) {
          // console.log('CHANNELS', this.pusherRef)
          const channel = this.pusherRef.channels.channels['presence-justification-in-progress']
          // console.log('CHANNEL', channel)
          channel.trigger(
            'client-justification-in-progress',
            {
              i: alarm.alarmId,
              t: 'movement',
              v: true,
              u: this.user.name
            }
          )
        }

        // console.log('ALARM', alarm)
        const type = 'movement'
        this.alarmSelected = {
          ...alarm.justification,
          alarmId: alarm.alarmId,
          licensePlate: alarm.licensePlate,
          code: alarm.code,
          type
        }
        // console.log('alarmSelected', this.alarmSelected)
        this.showJustification = true
      },
      showMessageIn(data) {
        this.messageToShow = data.message
        this.showMessage = true
      },
      closeMessage() {
        this.messageToShow = ''
        this.showMessage = false
      }
    },
    mounted() {
      // console.log('MOUNTED MOVEMENT ALERTS')
      this.setLoadingMovementAlarms(true)
      this.fetchMovementAlarms()
      this.intervalForMovementAlarms()
    },
    beforeDestroy() {
      // console.log('BEFORE DESTROY MOVEMENT ALERTS: ', this.intervalMovementAlarmsInstance)
      clearInterval(this.intervalMovementAlarmsInstance)
      this.clearMovementAlarms()
    }
  }
</script>

<style lang="stylus" scoped>
a
  text-decoration none
  color white
  font-size 16px

a:hover
  opacity 0.7

.hover-custom
  cursor pointer

.hover-custom:hover
  opacity 0.7

.cell-width-0
  min-width 120px
  max-width 120px

.cell-width-1
  min-width 160px
  max-width 160px

.cell-width-2
  min-width 170px
  max-width 170px

.cell-width-3
  min-width 110px
  max-width 110px

.small-text
  font-size 8px

// .info-vehicle
//   width 120px

.header-container
  min-width 960px
  max-width 1024px
  height 35px
  border-radius 3px
  background-color #424242
  font-size 16px
  font-weight 500

.general-info-container
  height 70px
  border-radius 3px
  background-color #424242

.info-width
  min-width 1024px
  max-width 1024px

.hover-icon:hover
  cursor: pointer

.in-progress-state
  border dashed 1px #FFD54F
  border-radius 10px
  max-width 85px
  min-width 85px
  max-height 50px
  min-height 50px
  margin-left -15px
  padding-right 15px
</style>



// WEBPACK FOOTER //
// src/components/MovementAlerts.vue